import { getQueryClient } from "@/services/get-query-client";

export async function fetchPartialSettings<T>(): Promise<T> {
  const queryClient = getQueryClient();
  
  return await queryClient.fetchQuery({
    queryKey: ["settings"],
    queryFn: async () => {
      const response = await fetch("/api/avatar_settings", {
        method: "GET",
        signal: new AbortController().signal, // Optional: Use AbortController for cancellation
      });
      
      if (!response.ok) {
        throw new Error(`Failed to fetch settings: ${response.status}`);
      }
      
      return response.json();
    },
  });
}
